<template>
  <div>
    <div class="app-container">
      <router-link v-auth="`payPasswordEditBtn`" :to="{ name: 'CheckBirthday' }">
        <Block class="my-block-item">
          <md-cell-item :title="$t('paymentPassword')" arrow>
            <span slot="left" class="holder">
              <svg-icon name="me-card" class="icon-card" />
            </span>
          </md-cell-item>
        </Block>
      </router-link>
    </div>
  </div>
</template>

<script>
// 支付设置页面
import Block from '@/components/Block'
import { CellItem } from 'mand-mobile'
export default {
  name: 'MePaySet',
  components: {
    Block,
    [CellItem.name]: CellItem
  }
}
</script>

<style lang='scss' scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */

.my-block-item {
  ::v-deep .flash-block__content {
    border-radius: 32px;

    .flash-block_body {
      padding: 0 40px 0 24px;
    }

    .md-cell-item-body {
      padding-top: 46px;
      padding-bottom: 46px;

      &::before {
        display: none;
      }
    }

    .holder {
      width: 64px;
      height: 64px;
      border-radius: 32px;

      .svg-icon {
        color: #ffc300;
        width: 48px;
        height: 48px;
      }
    }

    .md-cell-item-left {
      margin-right: 28px;
    }
  }
}
/* stylelint-enable */
</style>
